<!-- SearchNoteInput.vue -->
<!-- PATCH: ao disparar busca global, reseta os filtros de campo
     filterByTitle, filterByBody e filterByTag (conforme spec).
     filterBySource NÃO é resetado pela busca global. -->
     <script setup>
     import { ref, watch, onBeforeUnmount } from "vue";
     import { useNoteStore } from "@/stores/useNoteStore";
     import { useActivityStore } from "@/stores/useActivityStore";
     import debounce from "lodash.debounce";
     
     const noteStore = useNoteStore();
     const activityStore = useActivityStore();
     
     const search = ref(noteStore.searchTerm);
     
     const debouncedSearch = debounce(async () => {
       noteStore.currentPage = 1;
       noteStore.searchTerm = search.value;
       noteStore.shouldForcePageOne = true;
     
       // >>> PATCH: reseta filtros de campo quando o usuário usa a busca global
       // Somente quando há texto digitado (não reseta ao limpar o campo)
       if (search.value.trim() !== "") {
         noteStore.resetFieldFilters(); // reseta título, conteúdo e tag (não fonte)
       }
     
       await noteStore.fetchNotesByActivityIdPaged(
         activityStore.idActivity,
         1,
         noteStore.pageSize,
         noteStore.searchTerm
       );
     }, 400);
     
     watch(search, () => {
       debouncedSearch();
     });
     
     watch(
       () => activityStore.idActivity,
       (newVal, oldVal) => {
         if (!newVal || newVal === oldVal) return;
         debouncedSearch.cancel();
         search.value = "";
         noteStore.searchTerm = "";
       }
     );
     
     onBeforeUnmount(() => {
       debouncedSearch.cancel();
       search.value = "";
       noteStore.searchTerm = "";
       noteStore.currentPage = 1;
       noteStore.shouldForcePageOne = true;
     });
     </script>
     
     <template>
       <div class="search-input-wrapper">
         <div class="icon-wrapper">
           <svg
             aria-hidden="true"
             class="search-icon"
             fill="currentColor"
             viewBox="0 0 20 20"
             xmlns="http://www.w3.org/2000/svg"
           >
             <path
               fill-rule="evenodd"
               d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
               clip-rule="evenodd"
             ></path>
           </svg>
         </div>
     
         <input
           v-model="search"
           type="text"
           id="simple-search-notes"
           placeholder="Buscar por título, corpo e tag"
           class="input-base"
           style="padding-left: 2rem; border-radius: 12px;"
         />
       </div>
     </template>
     
     <style scoped>
.search-icon {
  width: 1rem;
}
     
</style>